module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9580.e1f724af.jpg";